const s = {
  name: "UserBusiness",
  dimensions: { width: 36, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 40" style="enable-background:new 0 0 36 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,8c0-4.4,3.6-8,8-8s8,3.6,8,8c0,4.4-3.6,8-8,8S10,12.4,10,8z M18,2c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6
			S21.3,2,18,2z"/>
		<path class="st0" d="M0,29c0-6.1,4.9-11,11-11h14c6.1,0,11,4.9,11,11v11h-2V29c0-5-4-9-9-9h-2.5l-3.4,5.1l4,10L19.5,40h-3
			l-3.6-4.8l4-10L13.5,20H11c-5,0-9,4-9,9v11H0V29z M15.9,20l2.1,3.2l2.1-3.2H15.9z M15.1,34.9l2.4,3.2h1l2.4-3.2L18,27.7L15.1,34.9
			z"/>
		<path class="st0" d="M6,30v10h2V30H6z"/>
		<path class="st0" d="M28,40V30h2v10H28z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UserBusiness
};
